import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import Slide from '@mui/material/Slide';
import TimerIcon from '@material-ui/icons/Timer';
import classNames from 'classnames';
import useMobileLayout from 'Hooks/useMobileLayout';
import { dataAttrs } from 'Helpers/Testing';
import styles from './styles';

function WelcomeLayout({
  classes,
  children,
  showFooter,
}) {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  const title = resource.attr('title');
  const expectedDuration = resource.attr('expectedDuration');

  const isMobile = useMobileLayout();

  return (
    <div className={classes.root} {...dataAttrs('welcome-layout')}>
      <Slide
        direction={'down'}
        in
      >
        <div className={classNames(classes.imageCardContainer, { [classes.imageCardContainerDesktop]: !isMobile })}>
          <div className={classes.imageCardContent}>
            <div className={classes.imageCardHeader}>
              <Typography
                className={classes.titleText}
                color={'white'}
                variant={'h2'}
                weight={'medium'}
              >
                {title}
              </Typography>
              {expectedDuration ? (
                <Typography
                  className={classes.durationText}
                  color={'white'}
                  variant={'h4'}
                  weight={'medium'}
                >
                  <TimerIcon className={classes.durationIcon} />
                  {expectedDuration}
                </Typography>
              ) : null}
            </div>
          </div>
        </div>
      </Slide>
      {children}
      {/* ---------- Footer (Navigator) ---------- */}
      {showFooter && (
        <SurveyStepFooter
          className={classes.footer}
          onSubmit={onSubmitMetaForm}
          NextButtonProps={{
            buttonLabel: 'Get Started',
            test: 'survey-navigator-next-button',
          }}
        />
      )}
    </div>
  );
}

WelcomeLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  showFooter: PropTypes.bool,

};

WelcomeLayout.defaultProps = {
  showFooter: true,
};

export default withStyles(styles)(WelcomeLayout);
